export const intersectionObserverMixin = {
    data() {
        return {
            observer: null,
            observerOnce: null,
        }
    },
    methods: {
        // This is a more flexible Observe method that remains persistant and can take actions
        // when you enter and when you leave the viewport
        observe(target, enterCallback, exitCallback, options) {
            // browser doesn't support IO, just callback
            if (!window.IntersectionObserver) {
                enterCallback()
                return
            }

            // If the observer has already been created then we need to clean up first
            if (this.observer) {
                this.observer.disconnect()
            }

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        enterCallback()
                    } else {
                        exitCallback()
                    }
                })
            }, options)

            this.observer.observe(target)
        },
        // This is a legacy method that runs one time when the target enters within the
        // rootmargin of 150px of the viewport.
        // optionsObj allows us to change the rootMargin or add additional options.
        observeOnce(target, callback, optionsObj) {
            // browser doesn't support IO, just callback
            if (!window.IntersectionObserver) {
                callback()
                return
            }

            // If the observer has already been created then we need to clean up first
            if (this.observerOnce) {
                this.observerOnce.disconnect()
            }
            // for now all items will start to load 150px before they come into view
            const options = {
                rootMargin: '150px',
                ...optionsObj,
            }

            this.observerOnce = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback()
                        this.observerOnce.disconnect()
                    }
                })
            }, options)

            this.observerOnce.observe(target)
        },
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect()
        }
        if (this.observerOnce) {
            this.observerOnce.disconnect()
        }
    },
}
